<template>
  <v-card class="pa-5a text-center">
    <v-list-item-title class="title">Game Over!</v-list-item-title>
    <v-list subheader>
      <v-list-item v-for="item in players" :key="item.index">
        <v-list-item-content class="text-right align-self-start">
          <v-list-item-title v-text="item.player"></v-list-item-title>
        </v-list-item-content>

        <v-list-item-content class="text-left align-self-start ml-5">
          <v-list-item-title v-text="item.score"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn width="100%" @click="playagain">Play Again!</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import refs from "./firebase/refs";
import game_play from "./firebase/game_play";

export default {
  name: "GameOver",
  props: {
    gameId: String,
  },
  async created() {
    await this.loadPlayersAndScores();
  },
  methods: {
    async loadPlayersAndScores() {
      var tempPlayers = [];
      await refs.players(this.gameId).once("value", (snapshot) => {
        snapshot.forEach((p) => {
          tempPlayers.push({ player: p.val().player, score: p.val().score });
        });
      });

      tempPlayers.sort(function(a, b) {
        return b.score - a.score;
      });
      this.players = tempPlayers;
    },
    async playagain() {
      await game_play.playAgain(this.gameId);
    },
  },
  data() {
    return {
      players: [],
    };
  },
};
</script>
